import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";

import { ProductDetailsFragment } from "@/saleor/api";

interface ProductPageSeoProps {
	product: ProductDetailsFragment;
}

export const ProductPageSeo = ({ product }: ProductPageSeoProps) => {
	const title = `${product?.seoTitle || product?.name} - ${t`GoalsMapper Rewards`}`;
	const description = product?.seoDescription || t`Welcome to Goalsmapper Rewards.`;
	const thumbnailUrl = product.thumbnail?.url || "";
	const thumbnailAlt = product.thumbnail?.alt || title;

	return (
		<NextSeo
			title={title}
			description={description}
			openGraph={{
				title,
				description,
				images: [
					{
						url: thumbnailUrl,
						alt: thumbnailAlt,
					},
				],
				site_name: t`GoalsMapper Rewards`,
			}}
		/>
	);
};

export default ProductPageSeo;
